import ActionHint from '../ActionHint';
import { AI_BADGE_LABEL, AI_BADGE_TITLE, MARK_AS_LABEL } from '../constants';
import {
  AiBadge,
  AiLineTag,
  AttemptAiLine,
  AttemptFoot,
  AttemptId,
  AttemptIdRow,
  AttemptNote,
  AttemptRow,
  AttemptSummary,
  AttemptTime,
  AttemptTop,
  DispositionBadge,
  MarkAsButton,
  ResolveFlag,
} from './styled';
import DocumentChips from './DocumentChips';
import type { AttemptCardProps } from './types';
import { getAttemptCardView } from './utils';

const AttemptCard = ({ attempt, resolution, attempts = [], markAsReason = null, onMarkAs }: AttemptCardProps) => {
  const view = getAttemptCardView(attempt, resolution, attempts);

  return (
    <AttemptRow
      resolving={view.resolving}
      data-testid={`idv-attempt-${attempt.id}`}
      data-resolving={String(view.resolving)}
    >
      <AttemptTop>
        <AttemptIdRow>
          <AttemptId>{view.idLabel}</AttemptId>
          {view.aiBadge ? (
            <AiBadge title={AI_BADGE_TITLE} data-testid="idv-ai-badge">
              {AI_BADGE_LABEL}
            </AiBadge>
          ) : null}
          <DispositionBadge tone={view.disposition.tone} data-testid="idv-disposition-badge">
            {view.disposition.label}
          </DispositionBadge>
          {view.resolveFlag ? <ResolveFlag data-testid="idv-resolve-flag">{view.resolveFlag}</ResolveFlag> : null}
        </AttemptIdRow>
        <AttemptTime>{view.submittedLabel}</AttemptTime>
      </AttemptTop>
      <AttemptSummary data-testid="idv-attempt-summary">
        <b>{view.summaryCount}</b>
        {view.summaryTypes ? ` · ${view.summaryTypes}` : null}
      </AttemptSummary>
      {view.aiSummary ? (
        <AttemptAiLine data-testid="idv-ai-summary">
          <AiLineTag>{AI_BADGE_LABEL}</AiLineTag>
          <span>{view.aiSummary}</span>
        </AttemptAiLine>
      ) : null}
      <DocumentChips documents={attempt.documents} />
      <AttemptFoot>
        {view.note ? <AttemptNote data-testid="idv-attempt-note">{view.note}</AttemptNote> : <span />}
        <ActionHint title={view.canMarkAs ? null : markAsReason} testId="idv-mark-as-hint" blocked={!view.canMarkAs}>
          <MarkAsButton
            type="button"
            markVariant={view.markAsVariant}
            disabled={!view.canMarkAs}
            data-testid="idv-mark-as"
            data-variant={view.markAsVariant}
            onClick={() => onMarkAs?.(attempt.id)}
          >
            {MARK_AS_LABEL}
          </MarkAsButton>
        </ActionHint>
      </AttemptFoot>
    </AttemptRow>
  );
};

export default AttemptCard;
